const typographyFormService = {
  true: 'Novo Serviço',
  false: 'Detalhes do Serviço',
  signature: 'ASSINATURA',
  signatures: 'ASSINATURAS',
  signatureLabel: 'Assinatura',
  attachFiles: 'ANEXAR ARQUIVOS',
  addSignature: 'Adicionar Assinatura',
  addSignatures: 'Adicione assinaturas ao serviço',
  mandatorySignature: 'A Assinatura é obrigatória para esse serviço',
  complement: 'Complemento',
};

export default typographyFormService;
